import { DashboardSdk } from '@bringg/frontend-utils';
import axios from 'axios';

import { getAdminApiEndpoint } from '../../helpers';

export type DriverLoginTokenResponse = {
  access_token: string;
  rc: number;
  region: string;
  secret: string;
  success: boolean;
};

export async function getDriverLoginQRCode(
  dashboardSDK: DashboardSdk,
  userId: number
): Promise<DriverLoginTokenResponse> {
  return (
    await axios.get<DriverLoginTokenResponse>(
      `${getAdminApiEndpoint(dashboardSDK)}/tokens/gen_driver_qr_code?user_id=${userId}`
    )
  ).data;
}
